module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (2).42c7006a.jpg";